import { ICommonSettings } from "@kuika/kuika-cl-model";
import { PureComponent, ReactNode } from "react";
import { ICommonConfigDeleteFunctionParams, ICommonConfigSaveFunctionParams } from "../app-settings-config-container";
import { ConfigSettingSelect } from "../config-setting-select";
import { GoogleRecaptchaAndroidSettings } from "./app-settings-config-google-android-recaptcha";

export interface IGoogleRecaptchaAndroidInputState {
  showModal: boolean;
  googleRecaptchaAndroidSettingsId: string;
}

export interface IGoogleRecaptchaAndroidInputProps {
  parentConfigValue?: string | null;
  commonSettings: ICommonSettings;
  getSectionDescription: (contentKey: string) => ReactNode;
  handleUpdateCustomFormInput: (formItemName: string[], value: string | null) => void;
  handleCreateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleUpdateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleDeleteCommonConfig: (params: ICommonConfigDeleteFunctionParams) => void;
}

export class GoogleRecaptchaAndroidInput extends PureComponent<
  IGoogleRecaptchaAndroidInputProps,
  IGoogleRecaptchaAndroidInputState
> {
  formInputName = ["androidConfig", "googleRecaptchaAndroidSettingsId"];

  constructor(props: IGoogleRecaptchaAndroidInputProps) {
    super(props);
    this.state = {
      showModal: false,
      googleRecaptchaAndroidSettingsId: ""
    };
  }

  openModal = () => {
    this.setState({ showModal: true, googleRecaptchaAndroidSettingsId: "" });
  };

  closeModal = () => {
    this.setState({ showModal: false });
  };

  setEditingSetting = (id: string) => {
    this.setState({ googleRecaptchaAndroidSettingsId: id, showModal: true });
  };

  handleRestore = (): void => {
    this.props.handleUpdateCustomFormInput?.(this.formInputName, this.props.parentConfigValue ?? null);
  };

  render() {
    const {
      parentConfigValue,
      commonSettings,
      getSectionDescription,
      handleUpdateCustomFormInput,
      handleCreateCommonConfig,
      handleUpdateCommonConfig,
      handleDeleteCommonConfig
    } = this.props;

    const options = [...(commonSettings.googleRecaptchaAndroidSettings || [])];

    return (
      <>
        <GoogleRecaptchaAndroidSettings
          formInputName={this.formInputName}
          closeModal={this.closeModal}
          showModal={this.state.showModal}
          editingGoogleRecaptchaAndroidSettingsId={this.state.googleRecaptchaAndroidSettingsId}
          commonSettings={commonSettings}
          getSectionDescription={getSectionDescription}
          handleCreateCommonConfig={handleCreateCommonConfig}
          handleUpdateCommonConfig={handleUpdateCommonConfig}
          handleDeleteCommonConfig={handleDeleteCommonConfig}
        />
        <ConfigSettingSelect
          label="Configuration"
          formInputName={this.formInputName}
          options={options}
          tooltipContentKey="androidconfig_googlerecaptcha_configuration"
          onAddNew={this.openModal}
          onEdit={this.setEditingSetting}
          parentConfigValue={this.props.parentConfigValue}
          onRestore={this.handleRestore}
          dropdownTestId="androidGoogleRecaptchaDropdown"
          addNewTestId="androidGoogleRecaptchaAddNew"
          editTestId="androidGoogleRecaptchaEditButton"
        />
      </>
    );
  }
}
